/**
 * @file 自定义类型的Dialog
 * @example
 *     custom({
 *         className: 'demo',
 *         canClose: false,
 *         contentComponent: LightMedal
 *     });
 *     LightMedal内部关闭dialog：
 *         this.props.closeDialog()
 *
 */

import {
    Dialog,
    DialogBody,
    IDialogProps,
} from '../../components/dialog/dialog';
import React , {Component  } from 'react';
import modalServiceWrapper, { IWrapperConfig } from './modalServiceWrapper';

export interface ICustomDialog extends IWrapperConfig, IDialogProps {
    showDialog?: boolean;
    afterClose?: () => void;
    childProps: {[propName: string]: any};
    width?: string;
}

class CustomDialog extends Component<ICustomDialog> {

    public static defaultProps = {
        showDialog: true,
        hasMask: true,
        className: '',
        canClose: false,
    };

    constructor(props: ICustomDialog) {
        super(props);
    }

    public componentDidUpdate() {
        const {
            showDialog,
            afterClose,
        } = this.props;
        if (!showDialog && afterClose) {
            afterClose();
        }
    }


    public render() {
        const {
            close,
            showDialog,
            hasMask,
            className,
            canClose,
            width,
        } = this.props;

        return (
            <Dialog
                show={!!showDialog}
                hasMask={hasMask}
                className={`modal-dialog ${className}`}
                canClose={canClose}
                close={close}
                width={width}
            >
                <DialogBody>
                    {this.props.children}
                </DialogBody>
            </Dialog>
        );
    }
}

export default modalServiceWrapper(CustomDialog, true);
